import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Stack, Button, IconButton, TextField, Typography } from '@mui/material_modern'
import { NavigateBefore, NavigateNext, CalendarToday } from '@mui/icons-material_modern'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { addToDate } from 'utils/data-manipulation/common'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'
import { useSelector } from 'react-redux'
import { getDateFormatPatternFromLocale } from 'utils/helpers'
import dayjs from 'dayjs'

const DispatchActiveTicketsDateSelector = ({ selectedDate, setSelectedDate }) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false)
  const { locale } = useSelector(state => state.auth)
  const { dateFormat, muiDateFormat } = getDateFormatPatternFromLocale(locale)

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="h6">
          {dateFormatter(selectedDate, null, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </Typography>
        {isDatePickerOpen && (
          // TODO: see if we can migrate to generic date picker or date picker v2
          <DatePicker
            value={selectedDate}
            onChange={newDate => {
              setSelectedDate(newDate)
              setIsDatePickerOpen(false)
            }}
            onClose={() => setIsDatePickerOpen(false)}
            open={isDatePickerOpen}
            inputFormat={muiDateFormat}
            renderInput={params => {
              const dateValue = dayjs(params.inputProps.value, dateFormat).valueOf()
              const inputValue =
                !isNaN(dateValue) && dayjs(dateValue).isValid() ? dateFormatter(dateValue) : params.inputProps.value
              return (
                <TextField
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    value: inputValue,
                    placeholder: dateFormat,
                  }}
                />
              )
            }}
          />
        )}
        <IconButton onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}>
          <CalendarToday />
        </IconButton>
        <Button variant="outlined" onClick={() => setSelectedDate(new Date())}>
          Today
        </Button>
        <Stack direction="row" alignItems="center">
          <IconButton onClick={() => setSelectedDate(addToDate(selectedDate, -1))}>
            <NavigateBefore />
          </IconButton>
          <IconButton onClick={() => setSelectedDate(addToDate(selectedDate, 1))}>
            <NavigateNext />
          </IconButton>
        </Stack>
      </Stack>
    </LocalizationProvider>
  )
}

DispatchActiveTicketsDateSelector.propTypes = {
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  setSelectedDate: PropTypes.func.isRequired,
}

export default DispatchActiveTicketsDateSelector
